<template>
  <multiselect
    v-model="selectedCrms"
    :id="this.$props.id ? this.$props.id : 'ajax'"
    :placeholder="placeholder"
    open-direction="bottom"
    :options="crmList"
    :multiple="true"
    :searchable="true"
    :disabled="this.$props.disabled"
    :loading="isLoading"
    :internal-search="false"
    :clear-on-select="false"
    :close-on-select="true"
    @close="handleSelect"
    @input="handleInput"
    :options-limit="15"
    :limit="5"
    :limit-text="limitText"
    :deselect-label="'Remover item'"
    :selected-label="'Selecionado'"
    :select-label="'Selecionar'"
    :max-height="600"
    :show-no-results="true"
    @search-change="asyncFindCrms"
  >
    <template #noOptions>
      <span class="custom-no-options"
        >Comece a escrever para inciar consulta.</span
      >
    </template>
    <template #clear="props">
      <div
        class="multiselect__clear"
        v-if="selectedCrms.length"
        @mousedown.prevent.stop="clearAll(props.search)"
      ></div>
    </template>
    <span slot="noResult"
      >Nenhum crm encontrado, tente refazer a consulta.</span
    >
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import getCrms from "../../services/crms/crms";
import { createToast } from "../toast/toast";

export default {
  components: { Multiselect },
  props: {
    crms: Array,
    toRemove: Array,
    toOnly: Array,
    disabled: Boolean,
    id: String,
    // Adicione aqui:
    placeholder: {
      type: String,
      default: ""
    }
  },
  async mounted() {
    this.selectedCrms.concat(this.$props.crms);
    if (!this.$props.disabled) this.getAllCrmsToCache();
  },
  data() {
    return {
      selectedCrms: [],
      crmList: [],
      crmListAll: [],
      isLoading: false,
    };
  },
  watch: {
    crms: {
      immediate: true,
      handler(newValue) {
        if (this.isArrayEmpty(newValue)) {
          this.selectedCrms = [...new Set([...this.selectedCrms])];
        } else {
          this.selectedCrms = [...new Set([...this.selectedCrms, ...newValue])];
        }
      },
    },
  },
  methods: {
    removeElement(elementToRemove) {
      const newList = this.selectedCrms.filter(
        (item) => item !== elementToRemove
      );
      if (newList.length !== this.selectedCrms.length) {
        this.selectedCrms = newList;
        this.$emit("onSelectCrm", this.selectedCrms);
      }
    },
    handleSelect() {
      this.crmList = [];
      this.$emit("onSelectCrm", this.selectedCrms);
    },
    handleInput(value) {
      this.$emit("onSelectCrm", value);
    },
    limitText(count) {
      return `e ${count} outros crms`;
    },
    getAllCrmsToCache() {
      this.isLoading = true;
      getCrms()
        .then((response) => {
          this.crmListAll = response;
          this.isLoading = false;
        })
        .catch((err) => {
          createToast("Erro", "Não foi possível consultar os crms.");
          console.error("getAllCrmsToCache", err);
          this.isLoading = false;
        });
    },
    isArrayEmpty(arr) {
      return !arr?.length;
    },
    asyncFindCrms(query) {
      let filteredList = this.crmListAll.filter((item) =>
        item.toUpperCase().includes(query.toUpperCase())
      );

      if (!this.isArrayEmpty(this.$props.toOnly)) {
        filteredList = filteredList.filter((item) =>
          this.$props.toOnly.includes(item)
        );
      } else if (!this.isArrayEmpty(this.$props.toRemove)) {
        filteredList = filteredList.filter(
          (item) =>
            !this.selectedCrms.includes(item) &&
            !this.$props.toRemove.includes(item)
        );
      } else {
        filteredList = filteredList.filter(
          (item) => !this.selectedCrms.includes(item)
        );
      }

      this.crmList = filteredList;
    },
    clearAll() {
      this.selectedCrms = [];
      this.$emit("onSelectCrm", this.selectedCrms);
    },
  },
};
</script>
<style lang="scss">
.multiselect__tag {
  background-color: #E6E6E6;
  color: #23272B;
  border-radius: 10px;
}
.multiselect__tag-icon:hover {
  background: #bccac4;
}
.multiselect__tag-icon:after {    
    color: #23272B;
}
</style>